import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CustomBtn from "./ButtonTemplate";

interface DelReqBtnProps {
  action: () => void;
  tip: string;
}

function DelReqBtn({ action, tip }: DelReqBtnProps) {
  return (
    <CustomBtn
      action={() => {
        action();
      }}
      type="danger"
      icon={<DeleteForeverIcon />}
      tip={tip}
    />
  );
}

export default DelReqBtn;
